// Generated from .\Source\worker\app-workers\shared\models\grammar-with-annotation\DataflowParser.g4 by ANTLR 4.8
// jshint ignore: start
var antlr4 = require('antlr4/index');

// This class defines a complete listener for a parse tree produced by DataflowParser.
function DataflowParserListener() {
	antlr4.tree.ParseTreeListener.call(this);
	return this;
}

DataflowParserListener.prototype = Object.create(antlr4.tree.ParseTreeListener.prototype);
DataflowParserListener.prototype.constructor = DataflowParserListener;

// Enter a parse tree produced by DataflowParser#IntegerLiteral.
DataflowParserListener.prototype.enterIntegerLiteral = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#IntegerLiteral.
DataflowParserListener.prototype.exitIntegerLiteral = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#FloatLiteral.
DataflowParserListener.prototype.enterFloatLiteral = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#FloatLiteral.
DataflowParserListener.prototype.exitFloatLiteral = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#StringLiteral.
DataflowParserListener.prototype.enterStringLiteral = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#StringLiteral.
DataflowParserListener.prototype.exitStringLiteral = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#RegexLiteral.
DataflowParserListener.prototype.enterRegexLiteral = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#RegexLiteral.
DataflowParserListener.prototype.exitRegexLiteral = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#integer_literal.
DataflowParserListener.prototype.enterInteger_literal = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#integer_literal.
DataflowParserListener.prototype.exitInteger_literal = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#index_literal.
DataflowParserListener.prototype.enterIndex_literal = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#index_literal.
DataflowParserListener.prototype.exitIndex_literal = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#format_literal.
DataflowParserListener.prototype.enterFormat_literal = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#format_literal.
DataflowParserListener.prototype.exitFormat_literal = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#extension_literal.
DataflowParserListener.prototype.enterExtension_literal = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#extension_literal.
DataflowParserListener.prototype.exitExtension_literal = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#float_literal.
DataflowParserListener.prototype.enterFloat_literal = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#float_literal.
DataflowParserListener.prototype.exitFloat_literal = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#typeNames.
DataflowParserListener.prototype.enterTypeNames = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#typeNames.
DataflowParserListener.prototype.exitTypeNames = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#keyword.
DataflowParserListener.prototype.enterKeyword = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#keyword.
DataflowParserListener.prototype.exitKeyword = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#basicName.
DataflowParserListener.prototype.enterBasicName = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#basicName.
DataflowParserListener.prototype.exitBasicName = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#anyName.
DataflowParserListener.prototype.enterAnyName = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#anyName.
DataflowParserListener.prototype.exitAnyName = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#memberIdentifier.
DataflowParserListener.prototype.enterMemberIdentifier = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#memberIdentifier.
DataflowParserListener.prototype.exitMemberIdentifier = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#columnIdentifier.
DataflowParserListener.prototype.enterColumnIdentifier = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#columnIdentifier.
DataflowParserListener.prototype.exitColumnIdentifier = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#variableReference.
DataflowParserListener.prototype.enterVariableReference = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#variableReference.
DataflowParserListener.prototype.exitVariableReference = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#metaVariableReference.
DataflowParserListener.prototype.enterMetaVariableReference = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#metaVariableReference.
DataflowParserListener.prototype.exitMetaVariableReference = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#metaPosReference.
DataflowParserListener.prototype.enterMetaPosReference = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#metaPosReference.
DataflowParserListener.prototype.exitMetaPosReference = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#metaMatchReference.
DataflowParserListener.prototype.enterMetaMatchReference = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#metaMatchReference.
DataflowParserListener.prototype.exitMetaMatchReference = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#metaArgumentReference.
DataflowParserListener.prototype.enterMetaArgumentReference = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#metaArgumentReference.
DataflowParserListener.prototype.exitMetaArgumentReference = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#parameter.
DataflowParserListener.prototype.enterParameter = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#parameter.
DataflowParserListener.prototype.exitParameter = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#variable.
DataflowParserListener.prototype.enterVariable = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#variable.
DataflowParserListener.prototype.exitVariable = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#sectionName.
DataflowParserListener.prototype.enterSectionName = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#sectionName.
DataflowParserListener.prototype.exitSectionName = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#basicFunction.
DataflowParserListener.prototype.enterBasicFunction = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#basicFunction.
DataflowParserListener.prototype.exitBasicFunction = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#metafunction.
DataflowParserListener.prototype.enterMetafunction = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#metafunction.
DataflowParserListener.prototype.exitMetafunction = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#BasicSelector.
DataflowParserListener.prototype.enterBasicSelector = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#BasicSelector.
DataflowParserListener.prototype.exitBasicSelector = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#AnySelector.
DataflowParserListener.prototype.enterAnySelector = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#AnySelector.
DataflowParserListener.prototype.exitAnySelector = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#columnOperand.
DataflowParserListener.prototype.enterColumnOperand = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#columnOperand.
DataflowParserListener.prototype.exitColumnOperand = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#transformFunction.
DataflowParserListener.prototype.enterTransformFunction = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#transformFunction.
DataflowParserListener.prototype.exitTransformFunction = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#transientOperand.
DataflowParserListener.prototype.enterTransientOperand = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#transientOperand.
DataflowParserListener.prototype.exitTransientOperand = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#parameterOperand.
DataflowParserListener.prototype.enterParameterOperand = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#parameterOperand.
DataflowParserListener.prototype.exitParameterOperand = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#InterpolateText.
DataflowParserListener.prototype.enterInterpolateText = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#InterpolateText.
DataflowParserListener.prototype.exitInterpolateText = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#InterpolateExpr.
DataflowParserListener.prototype.enterInterpolateExpr = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#InterpolateExpr.
DataflowParserListener.prototype.exitInterpolateExpr = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#Cast.
DataflowParserListener.prototype.enterCast = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#Cast.
DataflowParserListener.prototype.exitCast = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#AddMinus.
DataflowParserListener.prototype.enterAddMinus = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#AddMinus.
DataflowParserListener.prototype.exitAddMinus = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#VariableRef.
DataflowParserListener.prototype.enterVariableRef = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#VariableRef.
DataflowParserListener.prototype.exitVariableRef = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#Or.
DataflowParserListener.prototype.enterOr = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#Or.
DataflowParserListener.prototype.exitOr = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#ColumnOperandRef.
DataflowParserListener.prototype.enterColumnOperandRef = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#ColumnOperandRef.
DataflowParserListener.prototype.exitColumnOperandRef = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#Struct.
DataflowParserListener.prototype.enterStruct = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#Struct.
DataflowParserListener.prototype.exitStruct = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#MetaVariableRef.
DataflowParserListener.prototype.enterMetaVariableRef = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#MetaVariableRef.
DataflowParserListener.prototype.exitMetaVariableRef = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#MulDivMod.
DataflowParserListener.prototype.enterMulDivMod = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#MulDivMod.
DataflowParserListener.prototype.exitMulDivMod = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#EqNotEq.
DataflowParserListener.prototype.enterEqNotEq = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#EqNotEq.
DataflowParserListener.prototype.exitEqNotEq = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#MetaPosRef.
DataflowParserListener.prototype.enterMetaPosRef = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#MetaPosRef.
DataflowParserListener.prototype.exitMetaPosRef = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#TransformFunctionExpr.
DataflowParserListener.prototype.enterTransformFunctionExpr = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#TransformFunctionExpr.
DataflowParserListener.prototype.exitTransformFunctionExpr = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#Comparison.
DataflowParserListener.prototype.enterComparison = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#Comparison.
DataflowParserListener.prototype.exitComparison = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#ArrayIndexer.
DataflowParserListener.prototype.enterArrayIndexer = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#ArrayIndexer.
DataflowParserListener.prototype.exitArrayIndexer = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#TransientRef.
DataflowParserListener.prototype.enterTransientRef = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#TransientRef.
DataflowParserListener.prototype.exitTransientRef = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#LiteralExpr.
DataflowParserListener.prototype.enterLiteralExpr = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#LiteralExpr.
DataflowParserListener.prototype.exitLiteralExpr = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#FieldSelector.
DataflowParserListener.prototype.enterFieldSelector = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#FieldSelector.
DataflowParserListener.prototype.exitFieldSelector = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#FunctionExpr.
DataflowParserListener.prototype.enterFunctionExpr = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#FunctionExpr.
DataflowParserListener.prototype.exitFunctionExpr = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#EmptyArray.
DataflowParserListener.prototype.enterEmptyArray = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#EmptyArray.
DataflowParserListener.prototype.exitEmptyArray = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#UnaryMinus.
DataflowParserListener.prototype.enterUnaryMinus = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#UnaryMinus.
DataflowParserListener.prototype.exitUnaryMinus = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#CommentedExpression.
DataflowParserListener.prototype.enterCommentedExpression = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#CommentedExpression.
DataflowParserListener.prototype.exitCommentedExpression = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#Array.
DataflowParserListener.prototype.enterArray = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#Array.
DataflowParserListener.prototype.exitArray = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#MetaFunctionExpr.
DataflowParserListener.prototype.enterMetaFunctionExpr = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#MetaFunctionExpr.
DataflowParserListener.prototype.exitMetaFunctionExpr = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#Interpolation.
DataflowParserListener.prototype.enterInterpolation = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#Interpolation.
DataflowParserListener.prototype.exitInterpolation = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#Not.
DataflowParserListener.prototype.enterNot = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#Not.
DataflowParserListener.prototype.exitNot = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#ParameterRef.
DataflowParserListener.prototype.enterParameterRef = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#ParameterRef.
DataflowParserListener.prototype.exitParameterRef = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#Scope.
DataflowParserListener.prototype.enterScope = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#Scope.
DataflowParserListener.prototype.exitScope = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#And.
DataflowParserListener.prototype.enterAnd = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#And.
DataflowParserListener.prototype.exitAnd = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#MetaMatchRef.
DataflowParserListener.prototype.enterMetaMatchRef = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#MetaMatchRef.
DataflowParserListener.prototype.exitMetaMatchRef = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#Xor.
DataflowParserListener.prototype.enterXor = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#Xor.
DataflowParserListener.prototype.exitXor = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#MetaArgumentRef.
DataflowParserListener.prototype.enterMetaArgumentRef = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#MetaArgumentRef.
DataflowParserListener.prototype.exitMetaArgumentRef = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#Map.
DataflowParserListener.prototype.enterMap = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#Map.
DataflowParserListener.prototype.exitMap = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#assignment.
DataflowParserListener.prototype.enterAssignment = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#assignment.
DataflowParserListener.prototype.exitAssignment = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#transientAssignment.
DataflowParserListener.prototype.enterTransientAssignment = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#transientAssignment.
DataflowParserListener.prototype.exitTransientAssignment = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#metaAssignment.
DataflowParserListener.prototype.enterMetaAssignment = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#metaAssignment.
DataflowParserListener.prototype.exitMetaAssignment = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#sections.
DataflowParserListener.prototype.enterSections = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#sections.
DataflowParserListener.prototype.exitSections = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#section.
DataflowParserListener.prototype.enterSection = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#section.
DataflowParserListener.prototype.exitSection = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#key.
DataflowParserListener.prototype.enterKey = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#key.
DataflowParserListener.prototype.exitKey = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#keyExpression.
DataflowParserListener.prototype.enterKeyExpression = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#keyExpression.
DataflowParserListener.prototype.exitKeyExpression = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#configName.
DataflowParserListener.prototype.enterConfigName = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#configName.
DataflowParserListener.prototype.exitConfigName = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#configuration.
DataflowParserListener.prototype.enterConfiguration = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#configuration.
DataflowParserListener.prototype.exitConfiguration = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#transformation.
DataflowParserListener.prototype.enterTransformation = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#transformation.
DataflowParserListener.prototype.exitTransformation = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#transformName.
DataflowParserListener.prototype.enterTransformName = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#transformName.
DataflowParserListener.prototype.exitTransformName = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#transformed.
DataflowParserListener.prototype.enterTransformed = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#transformed.
DataflowParserListener.prototype.exitTransformed = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#groupName.
DataflowParserListener.prototype.enterGroupName = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#groupName.
DataflowParserListener.prototype.exitGroupName = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#transformedGroup.
DataflowParserListener.prototype.enterTransformedGroup = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#transformedGroup.
DataflowParserListener.prototype.exitTransformedGroup = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#inputTransformedList.
DataflowParserListener.prototype.enterInputTransformedList = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#inputTransformedList.
DataflowParserListener.prototype.exitInputTransformedList = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#inputDefinition.
DataflowParserListener.prototype.enterInputDefinition = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#inputDefinition.
DataflowParserListener.prototype.exitInputDefinition = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#outputDefinition.
DataflowParserListener.prototype.enterOutputDefinition = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#outputDefinition.
DataflowParserListener.prototype.exitOutputDefinition = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#outputTransformed.
DataflowParserListener.prototype.enterOutputTransformed = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#outputTransformed.
DataflowParserListener.prototype.exitOutputTransformed = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#flowStatement.
DataflowParserListener.prototype.enterFlowStatement = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#flowStatement.
DataflowParserListener.prototype.exitFlowStatement = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#IntegerType.
DataflowParserListener.prototype.enterIntegerType = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#IntegerType.
DataflowParserListener.prototype.exitIntegerType = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#ShortType.
DataflowParserListener.prototype.enterShortType = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#ShortType.
DataflowParserListener.prototype.exitShortType = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#LongType.
DataflowParserListener.prototype.enterLongType = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#LongType.
DataflowParserListener.prototype.exitLongType = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#DoubleType.
DataflowParserListener.prototype.enterDoubleType = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#DoubleType.
DataflowParserListener.prototype.exitDoubleType = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#FloatType.
DataflowParserListener.prototype.enterFloatType = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#FloatType.
DataflowParserListener.prototype.exitFloatType = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#BooleanType.
DataflowParserListener.prototype.enterBooleanType = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#BooleanType.
DataflowParserListener.prototype.exitBooleanType = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#StringType.
DataflowParserListener.prototype.enterStringType = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#StringType.
DataflowParserListener.prototype.exitStringType = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#DateType.
DataflowParserListener.prototype.enterDateType = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#DateType.
DataflowParserListener.prototype.exitDateType = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#ByteType.
DataflowParserListener.prototype.enterByteType = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#ByteType.
DataflowParserListener.prototype.exitByteType = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#BinaryType.
DataflowParserListener.prototype.enterBinaryType = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#BinaryType.
DataflowParserListener.prototype.exitBinaryType = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#TimestampType.
DataflowParserListener.prototype.enterTimestampType = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#TimestampType.
DataflowParserListener.prototype.exitTimestampType = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#DecimalType.
DataflowParserListener.prototype.enterDecimalType = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#DecimalType.
DataflowParserListener.prototype.exitDecimalType = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#IntegralType.
DataflowParserListener.prototype.enterIntegralType = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#IntegralType.
DataflowParserListener.prototype.exitIntegralType = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#FractionalType.
DataflowParserListener.prototype.enterFractionalType = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#FractionalType.
DataflowParserListener.prototype.exitFractionalType = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#NumberType.
DataflowParserListener.prototype.enterNumberType = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#NumberType.
DataflowParserListener.prototype.exitNumberType = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#AnyType.
DataflowParserListener.prototype.enterAnyType = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#AnyType.
DataflowParserListener.prototype.exitAnyType = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#complex.
DataflowParserListener.prototype.enterComplex = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#complex.
DataflowParserListener.prototype.exitComplex = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#ArrayType.
DataflowParserListener.prototype.enterArrayType = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#ArrayType.
DataflowParserListener.prototype.exitArrayType = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#SimpleType.
DataflowParserListener.prototype.enterSimpleType = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#SimpleType.
DataflowParserListener.prototype.exitSimpleType = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#ComplexType.
DataflowParserListener.prototype.enterComplexType = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#ComplexType.
DataflowParserListener.prototype.exitComplexType = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#MapType.
DataflowParserListener.prototype.enterMapType = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#MapType.
DataflowParserListener.prototype.exitMapType = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#parameterDefinition.
DataflowParserListener.prototype.enterParameterDefinition = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#parameterDefinition.
DataflowParserListener.prototype.exitParameterDefinition = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#OneFormat.
DataflowParserListener.prototype.enterOneFormat = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#OneFormat.
DataflowParserListener.prototype.exitOneFormat = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#ManyFormats.
DataflowParserListener.prototype.enterManyFormats = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#ManyFormats.
DataflowParserListener.prototype.exitManyFormats = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#inlineDatatype.
DataflowParserListener.prototype.enterInlineDatatype = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#inlineDatatype.
DataflowParserListener.prototype.exitInlineDatatype = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#externalDatatype.
DataflowParserListener.prototype.enterExternalDatatype = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#externalDatatype.
DataflowParserListener.prototype.exitExternalDatatype = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#columnDefinition.
DataflowParserListener.prototype.enterColumnDefinition = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#columnDefinition.
DataflowParserListener.prototype.exitColumnDefinition = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#parameters.
DataflowParserListener.prototype.enterParameters = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#parameters.
DataflowParserListener.prototype.exitParameters = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#functionDefinition.
DataflowParserListener.prototype.enterFunctionDefinition = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#functionDefinition.
DataflowParserListener.prototype.exitFunctionDefinition = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#functions.
DataflowParserListener.prototype.enterFunctions = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#functions.
DataflowParserListener.prototype.exitFunctions = function(ctx) {
};


// Enter a parse tree produced by DataflowParser#dataflow.
DataflowParserListener.prototype.enterDataflow = function(ctx) {
};

// Exit a parse tree produced by DataflowParser#dataflow.
DataflowParserListener.prototype.exitDataflow = function(ctx) {
};



exports.DataflowParserListener = DataflowParserListener;